import { STEM_TYPE_DISPLAY_NAMES } from "@/constants/stemSplit";
import { StemType } from "@/types/defs/stemSplit";

export const getStemTypeDisplayName = (stemType: StemType): string => {
  return STEM_TYPE_DISPLAY_NAMES[stemType];
};
